const getters = {
  selectedCompany: state => {
    return state.selCompany ? state.selCompany : null
  }
}

export default getters
